var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-markdown"},[(!_vm.markedHTML)?_c('div',{staticClass:"spin-group"},[_c('div',[_vm._v("正在加载")])]):_vm._e(),_c('div',{staticClass:"markdown-body",domProps:{"innerHTML":_vm._s(_vm.markedHTML)}})])}
var staticRenderFns = []

export { render, staticRenderFns }